import { motion } from 'framer-motion'

export function IntroSection() {
  return (
    <section className="relative bg-wd-mist py-24 lg:py-32">
      <div className="grid-lines text-carbon">
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl px-6 text-center lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-6 font-condensed text-xs uppercase tracking-[0.2em] text-wd-orange"
        >
          The Last Note
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="font-display text-display-xl lg:text-display-2xl font-normal normal-case leading-[0.95]"
        >
          vast, intimate <span className="italic">& unforgettable.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mx-auto mt-8 max-w-text-block leading-relaxed text-carbon/70"
        >
          Setting out to find a signature scent remains one of life’s rare pleasures.
          Our collection is small, deliberate, and built around clear scent stories —
          places, temperatures, memories.
        </motion.p>
      </div>
    </section>
  )
}
